var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomiseIcon5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.46875 2.46875H9.875V9.875H2.46875V2.46875Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.125 2.46875H76.5312V9.875H69.125V2.46875Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.46875 69.125H9.875V76.5312H2.46875V69.125Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.125 69.125H76.5312V76.5312H69.125V69.125Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8281 33.3281V30.8594",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8281 45.6719V48.1406",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8281 40.7344V38.2656",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8281 25.9219V23.4531",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8281 53.0781V55.5469",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8281 18.5156V16.0469",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8281 60.4844V62.9531",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8281 11.1094V9.875",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M72.8281 67.8906V69.125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 33.3281V30.8594",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 45.6719V48.1406",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 40.7344V38.2656",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 25.9219V23.4531",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 53.0781V55.5469",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 18.5156V16.0469",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 60.4844V62.9531",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 11.1094V9.875",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M6.17188 67.8906V69.125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6719 72.8281H48.1406",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3281 72.8281H30.8594",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2656 72.8281H40.7344",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0781 72.8281H55.5469",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9219 72.8281H23.4531",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4844 72.8281H62.9531",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5156 72.8281H16.0469",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8906 72.8281H69.125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1094 72.8281H9.875",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6719 6.17188H48.1406",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3281 6.17188H30.8594",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2656 6.17188H40.7344",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0781 6.17188H55.5469",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9219 6.17188H23.4531",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4844 6.17188H62.9531",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5156 6.17188H16.0469",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8906 6.17188H69.125",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1094 6.17188H9.875",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6719 45.6719L65.4219 38.2656L59.25 32.0938L39.5 39.5L45.6719 45.6719Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3281 45.6719L13.5781 38.2656L19.75 32.0938L39.5 39.5L33.3281 45.6719Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 64.1875L59.25 56.7812V45.6719",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 45.6719V56.7812L39.5 64.1875V45.6719",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3281 18.5156L13.5781 25.9219L19.75 32.0938L39.5 24.6875L33.3281 18.5156Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6719 18.5156L65.4219 25.9219L59.25 32.0938L39.5 24.6875L45.6719 18.5156Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#006257"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomiseIcon5);
export default __webpack_public_path__ + "static/media/customise-icon-5.360e26c41d998e1ce2a28ee0d72aea29.svg";
export { ForwardRef as ReactComponent };